// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"116":"graphs","341":"modals","821":"eventlog","942":"admin-tools"}[chunkId] + "." + {"116":"2a5d04e8","341":"55ce48b3","821":"6240f624","942":"c23b2529"}[chunkId] + ".js";
};